/**
 * ⚠️ DO NOT MODIFY WITHOUT READING: lib/notebook/navigation/NOTEBOOK-SPA-OVERLAP-FIX.md
 * Global notebook route entry epoch — bumps on every SPA navigation into /notebook/*.
 * Next.js 16 Activity keeps hidden route DOM; a new epoch forces Provider remount + DOM purge.
 * syncNotebookRouteEntry must NOT bump during SSR (hydration-safe).
 */

const listeners = new Set()
let entryEpoch = 0
let lastPathname = null

export function getNotebookRouteEntryEpoch() {
  return entryEpoch
}

export function subscribeNotebookRouteEntry(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function emit() {
  for (const listener of listeners) {
    listener()
  }
}

/**
 * Call during render (Tracker) and from pathname effects.
 * Bumps epoch whenever pathname changes TO a notebook route.
 */
export function syncNotebookRouteEntry(pathname) {
  if (typeof pathname !== 'string') return entryEpoch

  const isNotebook = pathname.startsWith('/notebook/')
  if (!isNotebook) {
    lastPathname = pathname
    return entryEpoch
  }

  // Never bump during SSR — multiple server renders / client first paint must match.
  if (typeof window === 'undefined') {
    return entryEpoch
  }

  if (pathname !== lastPathname) {
    lastPathname = pathname
    entryEpoch += 1
    emit()
  }

  return entryEpoch
}

/** Force a new entry (tests / manual recovery). */
export function bumpNotebookRouteEntry() {
  entryEpoch += 1
  emit()
  return entryEpoch
}

export function isNotebookPathname(pathname) {
  return typeof pathname === 'string' && pathname.startsWith('/notebook/')
}
